export default function AlertsMockService($http) {
  'ngInject';
  this.getAllAlerts = function () {
    return $http.get('./app/fixtures/alerts.json');
  };

  this.getNotes = function () {
    return $http.get('./app/fixtures/alerts/alerts.detail.notes.json');
  };
}